export default __webpack_public_path__ + "static/product-unit-12-places-events-1a1d2b0597b028f511f3660b178d7c06.png";